:host .amfori-logo {
  &__font {
    fill: #1e5cb3;
    fill-opacity: 1;
    fill-rule: nonzero;
    stroke: none;
  }
}
